import(/* webpackMode: "eager" */ "/vercel/path0/src/sections/home/view/home-view.tsx")